import type { LanguagePack } from './types'

export const pa: LanguagePack = {
  navSaved: 'ਸੇਵ ਕੀਤੇ',
  navInfo: 'ਜਾਣਕਾਰੀ',
  homeTitle: 'ਆਪਣੇ ਕਾਗ਼ਜ਼ ਦੀ ਫ਼ੋਟੋ ਖਿੱਚੋ',
  homeHint: 'ਸਮਝੋ ਦੱਸੇਗਾ ਕਿ ਕਾਗ਼ਜ਼ ਵਿੱਚ ਕੀ ਲਿਖਿਆ ਹੈ ਅਤੇ ਤੁਹਾਨੂੰ ਅੱਗੇ ਕੀ ਕਰਨਾ ਹੈ।',
  takePhoto: 'ਫ਼ੋਟੋ ਖਿੱਚੋ',
  uploadFile: 'ਫ਼ੋਟੋ ਜਾਂ PDF ਪਾਓ',
  supportedFiles: 'ਫ਼ੋਟੋ (JPG, PNG, WEBP) ਜਾਂ PDF · 10 MB ਤੱਕ',
  chooseLanguage: 'ਕਿਸ ਭਾਸ਼ਾ ਵਿੱਚ ਸਮਝਣਾ ਹੈ',
  privacyLine: 'ਤੁਹਾਡਾ ਕਾਗ਼ਜ਼ ਇਸੇ ਫ਼ੋਨ ਉੱਤੇ ਪੜ੍ਹਿਆ ਜਾਂਦਾ ਹੈ। ਜਦੋਂ ਤੱਕ ਤੁਸੀਂ "ਸੇਵ ਕਰੋ" ਨਹੀਂ ਦੱਬਦੇ, ਕੁਝ ਵੀ ਸੇਵ ਨਹੀਂ ਹੁੰਦਾ।',

  previewTitle: 'ਕੀ ਫ਼ੋਟੋ ਠੀਕ ਹੈ?',
  rotate: 'ਘੁਮਾਓ',
  crop: 'ਕੱਟੋ',
  cropDone: 'ਹੋ ਗਿਆ',
  retake: 'ਦੁਬਾਰਾ ਖਿੱਚੋ',
  readNow: 'ਪੜ੍ਹੋ',
  docLanguageLabel: 'ਕਾਗ਼ਜ਼ ਕਿਸ ਭਾਸ਼ਾ ਵਿੱਚ ਲਿਖਿਆ ਹੈ?',
  docLanguageHint: 'ਅੰਗਰੇਜ਼ੀ ਹਮੇਸ਼ਾ ਨਾਲ ਪੜ੍ਹੀ ਜਾਂਦੀ ਹੈ।',

  stepCheck: 'ਫ਼ੋਟੋ ਜਾਂਚੀ ਜਾ ਰਹੀ ਹੈ…',
  stepRead: 'ਕਾਗ਼ਜ਼ ਪੜ੍ਹਿਆ ਜਾ ਰਿਹਾ ਹੈ…',
  stepExtract: 'ਜ਼ਰੂਰੀ ਜਾਣਕਾਰੀ ਲੱਭੀ ਜਾ ਰਹੀ ਹੈ…',
  stepExplain: 'ਪੰਜਾਬੀ ਵਿੱਚ ਸਮਝਾਇਆ ਜਾ ਰਿਹਾ ਹੈ…',
  firstTimeNote: 'ਪਹਿਲੀ ਵਾਰ ਥੋੜ੍ਹਾ ਜ਼ਿਆਦਾ ਸਮਾਂ ਲੱਗੇਗਾ, ਕਿਉਂਕਿ ਪੜ੍ਹਨ ਵਾਲਾ ਟੂਲ ਡਾਊਨਲੋਡ ਹੋ ਰਿਹਾ ਹੈ।',
  cancel: 'ਰੋਕੋ',

  errBadImage: 'ਫ਼ੋਟੋ ਥੋੜ੍ਹੀ ਸਾਫ਼ ਨਹੀਂ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਹੋਰ ਸਾਫ਼ ਫ਼ੋਟੋ ਖਿੱਚੋ।',
  errNoText: 'ਸਮਝੋ ਨੂੰ ਕਾਗ਼ਜ਼ ਉੱਤੇ ਲਿਖਿਆ ਹੋਇਆ ਕੁਝ ਨਹੀਂ ਮਿਲਿਆ।',
  errUnclearPart: 'ਇਸ ਹਿੱਸੇ ਨੂੰ ਸਮਝੋ ਠੀਕ ਤਰ੍ਹਾਂ ਪੜ੍ਹ ਨਹੀਂ ਸਕਿਆ।',
  errUnsupportedLanguage: 'ਇਸ ਭਾਸ਼ਾ ਦੀ ਸਹੂਲਤ ਅਜੇ ਨਹੀਂ ਹੈ।',
  errLongDocument: 'ਇਹ ਕਾਗ਼ਜ਼ ਕਾਫ਼ੀ ਲੰਮਾ ਹੈ। ਪਹਿਲਾਂ ਜ਼ਰੂਰੀ ਪੰਨੇ ਚੁਣੋ।',
  errFileType: 'ਕਿਰਪਾ ਕਰਕੇ ਫ਼ੋਟੋ (JPG, PNG, WEBP) ਜਾਂ PDF ਚੁਣੋ।',
  errFileSize: 'ਇਹ ਫ਼ਾਈਲ 10 MB ਤੋਂ ਵੱਡੀ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਛੋਟੀ ਫ਼ਾਈਲ ਚੁਣੋ।',
  errGeneric: 'ਕੁਝ ਗੜਬੜ ਹੋ ਗਈ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।',
  errOcrDownload: 'ਪੜ੍ਹਨ ਵਾਲਾ ਟੂਲ ਡਾਊਨਲੋਡ ਨਹੀਂ ਹੋ ਸਕਿਆ। ਇੱਕ ਵਾਰ ਇੰਟਰਨੈੱਟ ਚਾਲੂ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।',
  warnDark: 'ਫ਼ੋਟੋ ਵਿੱਚ ਹਨੇਰਾ ਹੈ। ਚੰਗੀ ਰੋਸ਼ਨੀ ਵਿੱਚ ਖਿੱਚੀ ਫ਼ੋਟੋ ਠੀਕ ਪੜ੍ਹੀ ਜਾਂਦੀ ਹੈ।',
  warnBlurry: 'ਫ਼ੋਟੋ ਧੁੰਦਲੀ ਲੱਗ ਰਹੀ ਹੈ। ਫ਼ੋਨ ਨੂੰ ਟਿਕਾ ਕੇ ਦੁਬਾਰਾ ਖਿੱਚੋ।',
  warnSmall: 'ਫ਼ੋਟੋ ਬਹੁਤ ਛੋਟੀ ਹੈ। ਕਾਗ਼ਜ਼ ਦੇ ਨੇੜੇ ਤੋਂ ਫ਼ੋਟੋ ਖਿੱਚੋ।',
  tryAgain: 'ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ',

  pickPagesHint: (max) => `ਵੱਧ ਤੋਂ ਵੱਧ ${max} ਪੰਨੇ ਚੁਣੋ।`,
  pageLabel: (n) => `ਪੰਨਾ ${n}`,
  readSelectedPages: (n) => `${n} ${n === 1 ? 'ਪੰਨਾ' : 'ਪੰਨੇ'} ਪੜ੍ਹੋ`,

  typeSure: (name) => `ਇਹ ${name} ਲੱਗਦਾ ਹੈ।`,
  typeMaybe: (name) => `ਇਹ ਸ਼ਾਇਦ ${name} ਹੈ, ਪਰ ਸਮਝੋ ਨੂੰ ਪੂਰਾ ਯਕੀਨ ਨਹੀਂ ਹੈ।`,
  typeUnknown: 'ਇਹ ਕਾਗ਼ਜ਼ ਕਿਸ ਤਰ੍ਹਾਂ ਦਾ ਹੈ, ਸਮਝੋ ਨੂੰ ਪੂਰਾ ਯਕੀਨ ਨਹੀਂ ਹੈ।',
  docTypes: {
    income_certificate: { name: 'ਆਮਦਨ ਸਰਟੀਫ਼ਿਕੇਟ', about: 'ਇਸ ਵਿੱਚ ਸਰਕਾਰੀ ਰਿਕਾਰਡ ਮੁਤਾਬਕ ਕਿਸੇ ਵਿਅਕਤੀ ਜਾਂ ਪਰਿਵਾਰ ਦੀ ਆਮਦਨ ਲਿਖੀ ਹੁੰਦੀ ਹੈ।' },
    caste_certificate: { name: 'ਜਾਤੀ ਸਰਟੀਫ਼ਿਕੇਟ', about: 'ਇਸ ਵਿੱਚ ਲਿਖਿਆ ਹੁੰਦਾ ਹੈ ਕਿ ਵਿਅਕਤੀ ਕਿਸ ਜਾਤੀ ਜਾਂ ਵਰਗ ਦਾ ਹੈ।' },
    domicile_certificate: { name: 'ਰਿਹਾਇਸ਼ੀ ਸਰਟੀਫ਼ਿਕੇਟ (ਡੋਮੀਸਾਈਲ)', about: 'ਇਸ ਵਿੱਚ ਲਿਖਿਆ ਹੁੰਦਾ ਹੈ ਕਿ ਵਿਅਕਤੀ ਪੱਕੇ ਤੌਰ ਉੱਤੇ ਕਿੱਥੇ ਰਹਿੰਦਾ ਹੈ।' },
    birth_certificate: { name: 'ਜਨਮ ਸਰਟੀਫ਼ਿਕੇਟ', about: 'ਇਹ ਜਨਮ ਦਾ ਸਰਕਾਰੀ ਰਿਕਾਰਡ ਹੈ।' },
    death_certificate: { name: 'ਮੌਤ ਦਾ ਸਰਟੀਫ਼ਿਕੇਟ', about: 'ਇਹ ਮੌਤ ਦਾ ਸਰਕਾਰੀ ਰਿਕਾਰਡ ਹੈ।' },
    electricity_bill: { name: 'ਬਿਜਲੀ ਦਾ ਬਿੱਲ', about: 'ਇਸ ਵਿੱਚ ਵਰਤੀ ਗਈ ਬਿਜਲੀ ਅਤੇ ਭਰਨ ਵਾਲੇ ਪੈਸੇ ਲਿਖੇ ਹੁੰਦੇ ਹਨ।' },
    water_bill: { name: 'ਪਾਣੀ ਦਾ ਬਿੱਲ', about: 'ਇਸ ਵਿੱਚ ਪਾਣੀ ਦੇ ਭਰਨ ਵਾਲੇ ਪੈਸੇ ਲਿਖੇ ਹੁੰਦੇ ਹਨ।' },
    ration_card: { name: 'ਰਾਸ਼ਨ ਕਾਰਡ ਜਾਂ ਰਾਸ਼ਨ ਦੀ ਸੂਚਨਾ', about: 'ਇਹ ਸਰਕਾਰੀ ਦੁਕਾਨ (ਡਿਪੂ) ਤੋਂ ਰਾਸ਼ਨ ਮਿਲਣ ਬਾਰੇ ਹੈ।' },
    aadhaar: { name: 'ਆਧਾਰ ਨਾਲ ਜੁੜਿਆ ਕਾਗ਼ਜ਼', about: 'ਇਹ ਆਧਾਰ ਨੰਬਰ ਜਾਂ ਆਧਾਰ ਦੀ ਜਾਣਕਾਰੀ ਬਾਰੇ ਹੈ।' },
    pan_card: { name: 'ਪੈਨ ਨਾਲ ਜੁੜਿਆ ਕਾਗ਼ਜ਼', about: 'ਇਹ ਪੈਨ (ਟੈਕਸ ਪਛਾਣ) ਨੰਬਰ ਬਾਰੇ ਹੈ।' },
    bank_notice: { name: 'ਬੈਂਕ ਦੀ ਚਿੱਠੀ', about: 'ਇਹ ਬੈਂਕ ਵੱਲੋਂ ਆਈ ਚਿੱਠੀ ਜਾਂ ਸੂਚਨਾ ਹੈ।' },
    loan_notice: { name: 'ਕਰਜ਼ੇ (ਲੋਨ) ਦੀ ਸੂਚਨਾ', about: 'ਇਹ ਕਿਸੇ ਲੋਨ ਜਾਂ ਬਕਾਇਆ ਪੈਸਿਆਂ ਬਾਰੇ ਹੈ।' },
    income_tax_notice: { name: 'ਇਨਕਮ ਟੈਕਸ ਦੀ ਸੂਚਨਾ', about: 'ਇਹ ਇਨਕਮ ਟੈਕਸ ਵਿਭਾਗ ਵੱਲੋਂ ਹੈ।' },
    pension: { name: 'ਪੈਨਸ਼ਨ ਬਾਰੇ ਚਿੱਠੀ', about: 'ਇਹ ਪੈਨਸ਼ਨ ਬਾਰੇ ਹੈ।' },
    court_notice: { name: 'ਅਦਾਲਤ ਜਾਂ ਕਾਨੂੰਨੀ ਨੋਟਿਸ', about: 'ਇਹ ਅਦਾਲਤ ਵੱਲੋਂ ਹੈ ਜਾਂ ਕਿਸੇ ਕਾਨੂੰਨੀ ਮਾਮਲੇ ਬਾਰੇ ਹੈ। ਇਸ ਨੂੰ ਗੰਭੀਰਤਾ ਨਾਲ ਲਓ।' },
    land_record: { name: 'ਜ਼ਮੀਨ ਦਾ ਰਿਕਾਰਡ', about: 'ਇਹ ਜ਼ਮੀਨ ਦੀ ਮਾਲਕੀ ਜਾਂ ਜ਼ਮੀਨ ਦੀ ਜਾਣਕਾਰੀ ਬਾਰੇ ਹੈ।' },
    property_tax: { name: 'ਪ੍ਰਾਪਰਟੀ ਟੈਕਸ (ਹਾਊਸ ਟੈਕਸ) ਦਾ ਬਿੱਲ', about: 'ਇਹ ਘਰ ਜਾਂ ਜਾਇਦਾਦ ਦੇ ਟੈਕਸ ਬਾਰੇ ਹੈ।' },
    scholarship: { name: 'ਵਜ਼ੀਫ਼ੇ (ਸਕਾਲਰਸ਼ਿਪ) ਦੀ ਚਿੱਠੀ', about: 'ਇਹ ਪੜ੍ਹਾਈ ਲਈ ਮਿਲਣ ਵਾਲੇ ਵਜ਼ੀਫ਼ੇ ਬਾਰੇ ਹੈ।' },
    farmer_scheme: { name: 'ਕਿਸਾਨ ਸਕੀਮ ਦੀ ਚਿੱਠੀ', about: 'ਇਹ ਕਿਸਾਨਾਂ ਲਈ ਕਿਸੇ ਸਕੀਮ ਜਾਂ ਮਦਦ ਬਾਰੇ ਹੈ।' },
    school_letter: { name: 'ਸਕੂਲ ਦੀ ਚਿੱਠੀ', about: 'ਇਹ ਸਕੂਲ ਵੱਲੋਂ ਹੈ ਜਾਂ ਪੜ੍ਹਾਈ ਬਾਰੇ ਹੈ।' },
    marksheet: { name: 'ਮਾਰਕਸ਼ੀਟ ਜਾਂ ਨਤੀਜਾ', about: 'ਇਸ ਵਿੱਚ ਇਮਤਿਹਾਨ ਦੇ ਨੰਬਰ ਜਾਂ ਨਤੀਜਾ ਲਿਖਿਆ ਹੈ।' },
    insurance: { name: 'ਬੀਮੇ ਦਾ ਕਾਗ਼ਜ਼', about: 'ਇਹ ਕਿਸੇ ਬੀਮਾ ਪਾਲਿਸੀ ਬਾਰੇ ਹੈ।' },
    traffic_challan: { name: 'ਟ੍ਰੈਫ਼ਿਕ ਚਲਾਨ', about: 'ਇਹ ਟ੍ਰੈਫ਼ਿਕ ਜਾਂ ਗੱਡੀ ਦਾ ਨਿਯਮ ਤੋੜਨ ਉੱਤੇ ਜੁਰਮਾਨਾ ਹੈ।' },
    job_notice: { name: 'ਨੌਕਰੀ ਜਾਂ ਪ੍ਰੀਖਿਆ ਦੀ ਸੂਚਨਾ', about: 'ਇਹ ਸਰਕਾਰੀ ਨੌਕਰੀ, ਭਰਤੀ ਜਾਂ ਉਸਦੀ ਪ੍ਰੀਖਿਆ ਬਾਰੇ ਹੈ।' },
    application_receipt: { name: 'ਅਰਜ਼ੀ ਦੀ ਰਸੀਦ', about: 'ਇਸ ਤੋਂ ਪਤਾ ਲੱਗਦਾ ਹੈ ਕਿ ਅਰਜ਼ੀ ਜਮ੍ਹਾਂ ਹੋ ਗਈ ਹੈ।' },
    application_decision: { name: 'ਅਰਜ਼ੀ ਬਾਰੇ ਚਿੱਠੀ', about: 'ਇਸ ਵਿੱਚ ਕਿਸੇ ਅਰਜ਼ੀ ਦਾ ਫ਼ੈਸਲਾ ਜਾਂ ਜਾਣਕਾਰੀ ਦਿੱਤੀ ਗਈ ਹੈ।' },
    government_notice: { name: 'ਸਰਕਾਰੀ ਸੂਚਨਾ', about: 'ਇਹ ਕਿਸੇ ਸਰਕਾਰੀ ਦਫ਼ਤਰ ਦੀ ਸੂਚਨਾ ਜਾਂ ਹੁਕਮ ਹੈ।' },
    lab_report: { name: 'ਮੈਡੀਕਲ ਜਾਂਚ ਰਿਪੋਰਟ', about: 'ਇਸ ਵਿੱਚ ਖ਼ੂਨ ਜਾਂ ਹੋਰ ਮੈਡੀਕਲ ਜਾਂਚਾਂ ਦੇ ਨਤੀਜੇ ਹਨ।' },
    rental_agreement: { name: 'ਕਿਰਾਇਆ ਇਕਰਾਰਨਾਮਾ', about: 'ਇਹ ਮਕਾਨ ਮਾਲਕ ਅਤੇ ਕਿਰਾਏਦਾਰ ਵਿਚਕਾਰ ਇਕਰਾਰਨਾਮਾ ਹੈ।' },
    loan_agreement: { name: 'ਕਰਜ਼ਾ ਇਕਰਾਰਨਾਮਾ', about: 'ਇਸ ਵਿੱਚ ਕਰਜ਼ੇ ਦੀਆਂ ਸ਼ਰਤਾਂ ਹਨ: ਵਿਆਜ, EMI ਅਤੇ ਖ਼ਰਚੇ।' },
    contract: { name: 'ਇੱਕ ਇਕਰਾਰਨਾਮਾ', about: 'ਇਹ ਇੱਕ ਇਕਰਾਰਨਾਮਾ ਹੈ, ਜਿਸ ਦੀਆਂ ਸ਼ਰਤਾਂ ਦੋਵਾਂ ਧਿਰਾਂ ਨੂੰ ਮੰਨਣੀਆਂ ਪੈਂਦੀਆਂ ਹਨ।' },
    unknown: { name: 'ਕਾਗ਼ਜ਼', about: '' }
  },

  seedhiBaat: 'ਸਿੱਧੀ ਗੱਲ',
  docSays: 'ਕਾਗ਼ਜ਼ ਵਿੱਚ ਲਿਖਿਆ ਹੈ',
  samjhoSays: 'ਸਮਝੋ ਦਾ ਮਤਲਬ',
  unclearText: 'ਇਹ ਹਿੱਸਾ ਸਾਫ਼ ਨਹੀਂ ਪੜ੍ਹਿਆ ਗਿਆ — ਕਿਰਪਾ ਕਰਕੇ ਅਸਲ ਕਾਗ਼ਜ਼ ਵੇਖੋ।',

  aboutPerson: (name) => `ਇਹ ਕਾਗ਼ਜ਼ ${name} ਬਾਰੇ ਹੈ।`,
  issuedBy: (authority) => `ਇਹ ਇੱਥੋਂ ਆਇਆ ਹੈ: ${authority}।`,
  status: {
    approved: 'ਅਰਜ਼ੀ ਮਨਜ਼ੂਰ ਹੋ ਗਈ ਹੈ।',
    rejected: 'ਅਰਜ਼ੀ ਨਾਮਨਜ਼ੂਰ (ਰਿਜੈਕਟ) ਕਰ ਦਿੱਤੀ ਗਈ ਹੈ।',
    pending: 'ਅਰਜ਼ੀ ਉੱਤੇ ਅਜੇ ਕੰਮ ਚੱਲ ਰਿਹਾ ਹੈ। ਅਜੇ ਫ਼ੈਸਲਾ ਨਹੀਂ ਹੋਇਆ।',
    cancelled: 'ਇਸ ਨੂੰ ਰੱਦ ਕਰ ਦਿੱਤਾ ਗਿਆ ਹੈ।'
  },
  dateSentence: {
    deadline: (d) => `ਆਖ਼ਰੀ ਤਾਰੀਖ਼: ${d}।`,
    due: (d) => `ਪੈਸੇ ਭਰਨ ਦੀ ਆਖ਼ਰੀ ਤਾਰੀਖ਼: ${d}।`,
    hearing: (d) => `ਕਾਗ਼ਜ਼ ਵਿੱਚ ਹਾਜ਼ਰ ਹੋਣ ਲਈ ਇਹ ਤਾਰੀਖ਼ ਲਿਖੀ ਹੈ: ${d}।`,
    issue: (d) => `ਇਹ ਕਾਗ਼ਜ਼ ${d} ਨੂੰ ਜਾਰੀ ਹੋਇਆ।`,
    validity: (d) => `ਇਹ ${d} ਤੱਕ ਮੰਨਣਯੋਗ ਹੈ।`,
    birth: (d) => `ਜਨਮ ਤਾਰੀਖ਼ ਲਿਖੀ ਹੈ: ${d}।`,
    other: (d) => `ਇੱਕ ਤਾਰੀਖ਼ ਲਿਖੀ ਹੈ: ${d}।`
  },
  daysLeft: (days) => (days === 1 ? '1 ਦਿਨ ਬਾਕੀ ਹੈ।' : `${days} ਦਿਨ ਬਾਕੀ ਹਨ।`),
  dueToday: 'ਇਹ ਤਾਰੀਖ਼ ਅੱਜ ਹੀ ਹੈ।',
  datePassed: 'ਧਿਆਨ ਦਿਓ: ਇਹ ਤਾਰੀਖ਼ ਲੰਘ ਚੁੱਕੀ ਹੈ।',
  amountSentence: {
    payable: (a) => `ਭਰਨ ਵਾਲੀ ਰਕਮ: ${a}।`,
    income: (a) => `ਲਿਖੀ ਗਈ ਆਮਦਨ: ${a}।`,
    fine: (a) => `ਜੁਰਮਾਨਾ ਜਾਂ ਦੇਰੀ ਦੀ ਫ਼ੀਸ ਲਿਖੀ ਹੈ: ${a}।`,
    fee: (a) => `ਫ਼ੀਸ ਲਿਖੀ ਹੈ: ${a}।`,
    sanctioned: (a) => `ਮਨਜ਼ੂਰ ਹੋਈ ਜਾਂ ਭੇਜੀ ਗਈ ਰਕਮ: ${a}।`,
    other: (a) => `ਇੱਕ ਰਕਮ ਲਿਖੀ ਹੈ: ${a}।`
  },
  actionsPointer: 'ਕਾਗ਼ਜ਼ ਵਿੱਚ ਤੁਹਾਨੂੰ ਕੁਝ ਕਰਨ ਲਈ ਕਿਹਾ ਗਿਆ ਹੈ। ਹੇਠਾਂ "ਤੁਹਾਨੂੰ ਕੀ ਕਰਨਾ ਹੈ" ਵੇਖੋ।',
  noActionFound: 'ਕਾਗ਼ਜ਼ ਵਿੱਚ ਤੁਹਾਨੂੰ ਕੁਝ ਕਰਨ ਦੀ ਗੱਲ ਸਾਫ਼ ਨਹੀਂ ਲਿਖੀ।',
  keepSafe: 'ਇਸ ਕਾਗ਼ਜ਼ ਨੂੰ ਸਾਂਭ ਕੇ ਰੱਖੋ।',
  doBefore: (d) => `ਇਹ ਕੰਮ ${d} ਤੋਂ ਪਹਿਲਾਂ ਕਰੋ।`,
  bringDocs: (list) => `ਇਹ ਕਾਗ਼ਜ਼ ਤਿਆਰ ਰੱਖੋ: ${list}।`,
  contactFor: (c) => `ਕੋਈ ਸਵਾਲ ਹੋਵੇ ਤਾਂ ਇੱਥੇ ਸੰਪਰਕ ਕਰੋ: ${c}।`,
  warningPointer: 'ਕਾਗ਼ਜ਼ ਵਿੱਚ ਇੱਕ ਚਿਤਾਵਨੀ ਲਿਖੀ ਹੈ। ਉਸ ਨੂੰ ਧਿਆਨ ਨਾਲ ਪੜ੍ਹੋ।',
  rejectedNext: 'ਜੇ ਤੁਹਾਨੂੰ ਲੱਗਦਾ ਹੈ ਕਿ ਗ਼ਲਤੀ ਹੋਈ ਹੈ, ਤਾਂ ਜਿਸ ਦਫ਼ਤਰ ਤੋਂ ਇਹ ਚਿੱਠੀ ਆਈ ਹੈ, ਉੱਥੇ ਪੁੱਛੋ।',
  lowQuality: 'ਫ਼ੋਟੋ ਬਹੁਤੀ ਸਾਫ਼ ਨਹੀਂ ਸੀ, ਇਸ ਲਈ ਕੁਝ ਗੱਲਾਂ ਗ਼ਲਤ ਪੜ੍ਹੀਆਂ ਗਈਆਂ ਹੋ ਸਕਦੀਆਂ ਹਨ। ਅਸਲ ਕਾਗ਼ਜ਼ ਨਾਲ ਮਿਲਾ ਲਓ।',

  cardTodo: 'ਤੁਹਾਨੂੰ ਕੀ ਕਰਨਾ ਹੈ',
  cardDates: 'ਜ਼ਰੂਰੀ ਤਾਰੀਖ਼ਾਂ',
  cardAmount: 'ਰਕਮ',
  cardWhere: 'ਕਿੱਥੇ ਜਾਣਾ ਹੈ',
  cardWarnings: 'ਧਿਆਨ ਰੱਖੋ',
  cardDocs: 'ਕਿਹੜੇ ਕਾਗ਼ਜ਼ ਚਾਹੀਦੇ ਹਨ',
  cardPerson: 'ਕਿਸ ਬਾਰੇ',
  cardFrom: 'ਕਿਸ ਨੇ ਭੇਜਿਆ',
  cardNumbers: 'ਜ਼ਰੂਰੀ ਨੰਬਰ',
  cardContact: 'ਸੰਪਰਕ',
  refKinds: {
    application: 'ਅਰਜ਼ੀ ਨੰਬਰ',
    certificate: 'ਸਰਟੀਫ਼ਿਕੇਟ ਨੰਬਰ',
    consumer: 'ਖਪਤਕਾਰ ਨੰਬਰ',
    account: 'ਖਾਤਾ ਨੰਬਰ',
    case: 'ਕੇਸ ਨੰਬਰ',
    reference: 'ਚਿੱਠੀ ਨੰਬਰ',
    registration: 'ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਨੰਬਰ',
    receipt: 'ਰਸੀਦ ਨੰਬਰ',
    other: 'ਨੰਬਰ'
  },
  requiredDocNames: {
    aadhaar: 'ਆਧਾਰ ਕਾਰਡ',
    pan: 'ਪੈਨ ਕਾਰਡ',
    ration_card: 'ਰਾਸ਼ਨ ਕਾਰਡ',
    voter_id: 'ਵੋਟਰ ਕਾਰਡ',
    passbook: 'ਬੈਂਕ ਪਾਸਬੁੱਕ',
    photo: 'ਫ਼ੋਟੋ',
    income_certificate: 'ਆਮਦਨ ਸਰਟੀਫ਼ਿਕੇਟ',
    caste_certificate: 'ਜਾਤੀ ਸਰਟੀਫ਼ਿਕੇਟ',
    domicile_certificate: 'ਰਿਹਾਇਸ਼ੀ ਸਰਟੀਫ਼ਿਕੇਟ',
    birth_certificate: 'ਜਨਮ ਸਰਟੀਫ਼ਿਕੇਟ',
    land_record: 'ਜ਼ਮੀਨ ਦਾ ਰਿਕਾਰਡ',
    electricity_bill: 'ਬਿਜਲੀ ਦਾ ਬਿੱਲ',
    address_proof: 'ਪਤੇ ਦਾ ਸਬੂਤ',
    id_proof: 'ਪਛਾਣ ਪੱਤਰ',
    affidavit: 'ਹਲਫ਼ਨਾਮਾ (ਐਫ਼ੀਡੇਵਿਟ)',
    application_form: 'ਅਰਜ਼ੀ ਫ਼ਾਰਮ'
  },

  voiceDownloadNote: 'ਪਹਿਲੀ ਵਾਰ ਆਵਾਜ਼ ਡਾਊਨਲੋਡ ਹੋ ਰਹੀ ਹੈ (ਲਗਭਗ 58 MB)। ਉਸ ਤੋਂ ਬਾਅਦ ਬਿਨਾਂ ਇੰਟਰਨੈੱਟ ਵੀ ਚੱਲੇਗੀ।',

  listen: 'ਸੁਣਾਓ',
  pause: 'ਰੁਕੋ',
  resume: 'ਅੱਗੇ ਸੁਣਾਓ',
  stop: 'ਬੰਦ ਕਰੋ',
  noVoice: 'ਇਸ ਫ਼ੋਨ ਵਿੱਚ ਪੰਜਾਬੀ ਦੀ ਆਵਾਜ਼ ਨਹੀਂ ਹੈ।',
  noVoiceHint: 'ਫ਼ੋਨ ਦੀ ਸੈਟਿੰਗ (Text-to-speech) ਵਿੱਚ ਆਵਾਜ਼ ਜੋੜ ਸਕਦੇ ਹੋ, ਜਾਂ ਕਿਸੇ ਹੋਰ ਭਾਸ਼ਾ ਵਿੱਚ ਸੁਣੋ।',
  listenInHindi: 'ਹਿੰਦੀ ਵਿੱਚ ਸੁਣਾਓ',
  listenInEnglish: 'ਅੰਗਰੇਜ਼ੀ ਵਿੱਚ ਸੁਣਾਓ',
  noSpeechSupport: 'ਇਹ ਬ੍ਰਾਊਜ਼ਰ ਬੋਲ ਕੇ ਨਹੀਂ ਸੁਣਾ ਸਕਦਾ।',

  disclaimer: 'ਸਮਝੋ ਤੁਹਾਡੇ ਕਾਗ਼ਜ਼ ਨੂੰ ਸੌਖਾ ਕਰਕੇ ਦੱਸਦਾ ਹੈ। ਜ਼ਰੂਰੀ ਗੱਲਾਂ ਹਮੇਸ਼ਾ ਅਸਲ ਕਾਗ਼ਜ਼ ਜਾਂ ਜਾਰੀ ਕਰਨ ਵਾਲੇ ਦਫ਼ਤਰ ਨਾਲ ਮਿਲਾ ਲਓ। ਸਮਝੋ ਸਰਕਾਰੀ ਸੇਵਾ ਨਹੀਂ ਹੈ ਅਤੇ ਇਹ ਕਾਨੂੰਨੀ ਸਲਾਹ ਨਹੀਂ ਹੈ।',
  fullText: 'ਸਮਝੋ ਨੇ ਕੀ ਪੜ੍ਹਿਆ',
  fullTextHint: 'ਰੰਗੀਆਂ ਹੋਈਆਂ ਲਾਈਨਾਂ ਸਾਫ਼ ਨਹੀਂ ਪੜ੍ਹੀਆਂ ਜਾ ਸਕੀਆਂ।',
  newDocument: 'ਨਵਾਂ ਕਾਗ਼ਜ਼',
  save: 'ਇਸ ਫ਼ੋਨ ਵਿੱਚ ਸੇਵ ਕਰੋ',
  saved: 'ਇਸ ਫ਼ੋਨ ਵਿੱਚ ਸੇਵ ਹੋ ਗਿਆ',
  share: 'ਸ਼ੇਅਰ ਕਰੋ',
  copied: 'ਕਾਪੀ ਹੋ ਗਿਆ',
  translateLines: 'ਕਾਗ਼ਜ਼ ਦੀਆਂ ਅੰਗਰੇਜ਼ੀ ਲਾਈਨਾਂ ਪੰਜਾਬੀ ਵਿੱਚ ਵੇਖੋ',
  helperMode: 'ਹੈਲਪਰ ਮੋਡ',
  helperModeHint: 'ਦੂਜਿਆਂ ਦੇ ਕਾਗ਼ਜ਼ ਪੜ੍ਹ ਕੇ ਦੇਣ ਵਾਲਿਆਂ ਲਈ (CSC, NGO, ਵਲੰਟੀਅਰ)। ਇਸ ਵਿੱਚ ਸੇਵ ਬੰਦ ਰਹਿੰਦਾ ਹੈ, ਅਤੇ "ਅਗਲਾ ਵਿਅਕਤੀ" ਦੱਬਣ ਨਾਲ ਸਭ ਮਿਟ ਜਾਂਦਾ ਹੈ।',
  nextPerson: 'ਅਗਲਾ ਵਿਅਕਤੀ',
  listenMode: 'ਸੁਣਨ ਵਾਲਾ ਮੋਡ',
  listenModeHint: 'ਸਮਝਾਉਣਾ ਤਿਆਰ ਹੁੰਦੇ ਹੀ ਸਮਝੋ ਉਸਨੂੰ ਆਪਣੇ-ਆਪ ਪੜ੍ਹ ਕੇ ਸੁਣਾਉਂਦਾ ਹੈ।',
  settingsTitle: 'ਸੈਟਿੰਗਾਂ',
  shareVoiceNote: 'ਵੌਇਸ ਨੋਟ ਭੇਜੋ',
  makingVoiceNote: 'ਵੌਇਸ ਨੋਟ ਬਣ ਰਿਹਾ ਹੈ…',
  voiceNoteFailed: 'ਇਸ ਫ਼ੋਨ ਉੱਤੇ ਵੌਇਸ ਨੋਟ ਨਹੀਂ ਬਣ ਸਕਿਆ।',
  translateOtherLines: 'ਕਾਗ਼ਜ਼ ਦੀਆਂ ਹੋਰ ਭਾਸ਼ਾ ਦੀਆਂ ਲਾਈਨਾਂ ਪੰਜਾਬੀ ਵਿੱਚ ਵੇਖੋ',
  translateAiNote: 'ਜੋ ਲਾਈਨਾਂ ਅੰਗਰੇਜ਼ੀ ਵਿੱਚ ਨਹੀਂ ਹਨ, ਉਨ੍ਹਾਂ ਦਾ ਅਨੁਵਾਦ ਇੱਕ AI ਸੇਵਾ (Groq) ਕਰਦੀ ਹੈ।',
  translateConsent: 'ਅਨੁਵਾਦ ਲਈ ਇਹ ਲਾਈਨਾਂ ਇੰਟਰਨੈੱਟ ਰਾਹੀਂ ਸਮਝੋ ਦੇ ਸਰਵਰ ਉੱਤੇ ਭੇਜੀਆਂ ਜਾਣਗੀਆਂ। ਉੱਥੇ ਇਹ ਸੇਵ ਨਹੀਂ ਹੁੰਦੀਆਂ। ਆਧਾਰ ਅਤੇ ਫ਼ੋਨ ਵਰਗੇ ਨੰਬਰ ਪਹਿਲਾਂ ਹੀ ਹਟਾ ਦਿੱਤੇ ਜਾਂਦੇ ਹਨ।',
  translateConfirm: 'ਹਾਂ, ਅਨੁਵਾਦ ਕਰੋ',
  translating: 'ਅਨੁਵਾਦ ਹੋ ਰਿਹਾ ਹੈ…',
  translateNote: 'ਮਸ਼ੀਨ ਨਾਲ ਅਨੁਵਾਦ — ਗ਼ਲਤੀ ਹੋ ਸਕਦੀ ਹੈ।',
  translateFailed: 'ਹੁਣ ਅਨੁਵਾਦ ਨਹੀਂ ਹੋ ਸਕਿਆ।',
  retryRotated: 'ਫ਼ੋਟੋ ਘੁਮਾ ਕੇ ਦੁਬਾਰਾ ਪੜ੍ਹੋ',

  addToCalendar: 'ਕੈਲੰਡਰ ਵਿੱਚ ਯਾਦ-ਦਹਾਨੀ ਜੋੜੋ',
  askTitle: 'ਇਸ ਕਾਗ਼ਜ਼ ਬਾਰੇ ਪੁੱਛੋ',
  askHint: 'ਆਪਣੇ ਸ਼ਬਦਾਂ ਵਿੱਚ ਪੁੱਛੋ। ਸਮਝੋ ਤੁਹਾਡੇ ਕਾਗ਼ਜ਼ ਤੋਂ ਜਵਾਬ ਦੇਵੇਗਾ — ਅਤੇ ਜੇ ਉੱਥੇ ਨਹੀਂ, ਤਾਂ ਸਿਰਫ਼ ਸਰਕਾਰੀ ਵੈੱਬਸਾਈਟਾਂ ਤੋਂ।',
  askPlaceholder: 'ਆਪਣਾ ਸਵਾਲ ਲਿਖੋ ਜਾਂ ਬੋਲੋ…',
  askSend: 'ਪੁੱਛੋ',
  askMic: 'ਬੋਲ ਕੇ ਪੁੱਛੋ',
  askListening: 'ਸੁਣ ਰਿਹਾ ਹੈ… ਹੁਣ ਬੋਲੋ',
  askWebToggle: 'ਲੋੜ ਹੋਵੇ ਤਾਂ ਸਰਕਾਰੀ ਵੈੱਬਸਾਈਟਾਂ ਵੀ ਵੇਖੋ',
  askConsent: 'ਜਵਾਬ ਦੇਣ ਲਈ ਇਸ ਕਾਗ਼ਜ਼ ਦੀ ਲਿਖਤ ਅਤੇ ਤੁਹਾਡਾ ਸਵਾਲ ਇੰਟਰਨੈੱਟ ਰਾਹੀਂ ਸਮਝੋ ਦੇ ਸਰਵਰ ਅਤੇ ਇੱਕ AI ਸੇਵਾ (Groq) ਉੱਤੇ ਭੇਜੇ ਜਾਣਗੇ। ਆਧਾਰ, ਪੈਨ, ਫ਼ੋਨ ਨੰਬਰ ਅਤੇ ਈਮੇਲ ਪਹਿਲਾਂ ਹੀ ਹਟਾ ਦਿੱਤੇ ਜਾਂਦੇ ਹਨ। ਕੁਝ ਵੀ ਸੇਵ ਨਹੀਂ ਹੁੰਦਾ।',
  askOfficialOnly: 'ਸਿਰਫ਼ ਸਰਕਾਰੀ ਵੈੱਬਸਾਈਟਾਂ ਵੇਖੀਆਂ ਜਾਂਦੀਆਂ ਹਨ, ਜਿਵੇਂ:',
  askConsentConfirm: 'ਠੀਕ ਹੈ, ਪੁੱਛੋ',
  askThinkingDoc: 'ਤੁਹਾਡਾ ਕਾਗ਼ਜ਼ ਪੜ੍ਹ ਰਹੇ ਹਾਂ',
  askThinkingWeb: 'ਸਰਕਾਰੀ ਵੈੱਬਸਾਈਟਾਂ ਵੇਖ ਰਹੇ ਹਾਂ',
  askFromDoc: 'ਤੁਹਾਡੇ ਕਾਗ਼ਜ਼ ਤੋਂ',
  askFromWeb: 'ਸਰਕਾਰੀ ਵੈੱਬਸਾਈਟ ਤੋਂ',
  askNotFound: 'ਸਮਝੋ ਨੂੰ ਇਹ ਗੱਲ ਨਾ ਤੁਹਾਡੇ ਕਾਗ਼ਜ਼ ਵਿੱਚ ਮਿਲੀ, ਨਾ ਸਰਕਾਰੀ ਵੈੱਬਸਾਈਟਾਂ ਉੱਤੇ। ਜਿਸ ਦਫ਼ਤਰ ਨੇ ਇਹ ਕਾਗ਼ਜ਼ ਭੇਜਿਆ ਹੈ, ਉਸ ਤੋਂ ਪੁੱਛੋ।',
  askUnverified: 'ਸਮਝੋ ਇਸਨੂੰ ਕਾਗ਼ਜ਼ ਦੀ ਕਿਸੇ ਪੱਕੀ ਲਾਈਨ ਨਾਲ ਨਹੀਂ ਮਿਲਾ ਸਕਿਆ। ਕਾਗ਼ਜ਼ ਵੇਖ ਕੇ ਜਾਂਚ ਲਵੋ।',
  askSources: 'ਸਰੋਤ',
  askOfficial: 'ਸਰਕਾਰੀ',
  askFailed: 'ਹੁਣੇ ਜਵਾਬ ਨਹੀਂ ਮਿਲ ਸਕਿਆ। ਫਿਰ ਕੋਸ਼ਿਸ਼ ਕਰੋ।',
  askBusy: 'ਹੁਣੇ ਬਹੁਤ ਸਵਾਲ ਆ ਰਹੇ ਹਨ। ਇੱਕ ਮਿੰਟ ਰੁਕ ਕੇ ਫਿਰ ਪੁੱਛੋ।',
  askAiNote: 'ਇਹ ਜਵਾਬ AI ਨੇ ਲਿਖੇ ਹਨ, ਗ਼ਲਤੀ ਹੋ ਸਕਦੀ ਹੈ। ਜ਼ਰੂਰੀ ਗੱਲਾਂ ਦਫ਼ਤਰ ਤੋਂ ਪੱਕੀਆਂ ਕਰ ਲਵੋ।',
  askTryNext: 'ਤੁਸੀਂ ਇਹ ਵੀ ਪੁੱਛ ਸਕਦੇ ਹੋ:',
  askJump: 'ਸਵਾਲ ਪੁੱਛੋ',
  askSuggest: {
    fillForm: 'ਇਹ ਫ਼ਾਰਮ ਕਿਵੇਂ ਭਰਾਂ? ਹਰ ਖ਼ਾਨਾ ਸਮਝਾਓ।',
    first: 'ਮੈਨੂੰ ਪਹਿਲਾਂ ਕੀ ਕਰਨਾ ਚਾਹੀਦਾ ਹੈ?',
    deadline: 'ਆਖ਼ਰੀ ਤਾਰੀਖ਼ ਲੰਘ ਗਈ ਤਾਂ ਕੀ ਹੋਵੇਗਾ?',
    pay: 'ਇਹ ਕਿਵੇਂ ਅਤੇ ਕਿੱਥੇ ਭਰਨਾ ਹੈ?',
    papers: 'ਇਹ ਕਾਗ਼ਜ਼ ਕਿੱਥੋਂ ਮਿਲਣਗੇ?',
    rejected: 'ਇਹ ਕਿਉਂ ਰੱਦ ਹੋਇਆ, ਅਤੇ ਹੁਣ ਮੈਂ ਕੀ ਕਰ ਸਕਦਾ ਹਾਂ?',
    meaning: 'ਇਸ ਕਾਗ਼ਜ਼ ਨੂੰ ਬਹੁਤ ਸੌਖੇ ਸ਼ਬਦਾਂ ਵਿੱਚ ਸਮਝਾਓ।',
    contact: 'ਇਸ ਬਾਰੇ ਕਿਸ ਨਾਲ ਗੱਲ ਕਰਾਂ?',
    schemes: 'ਇਸ ਕਾਗ਼ਜ਼ ਦੇ ਹਿਸਾਬ ਨਾਲ ਮੈਂ ਕਿਹੜੀਆਂ ਸਰਕਾਰੀ ਸਕੀਮਾਂ ਲਈ ਯੋਗ ਹੋ ਸਕਦਾ ਹਾਂ?'
  },

  helpTitle: 'ਮਦਦ ਲਵੋ',
  nearbyTitle: 'ਸਭ ਤੋਂ ਨੇੜਲਾ ਦਫ਼ਤਰ',
  nearbyNote: 'ਤੁਹਾਡੇ ਨੇੜੇ ਦਾ ਨਕਸ਼ਾ ਖੁੱਲ੍ਹੇਗਾ। ਤੁਹਾਡੀ ਲੋਕੇਸ਼ਨ ਸਿਰਫ਼ ਨਕਸ਼ੇ ਨੂੰ ਜਾਂਦੀ ਹੈ — ਸਮਝੋ ਉਸਨੂੰ ਨਾ ਵੇਖਦਾ ਹੈ, ਨਾ ਸਾਂਭਦਾ ਹੈ।',
  locating: 'ਤੁਹਾਡੀ ਲੋਕੇਸ਼ਨ ਲੱਭ ਰਹੇ ਹਾਂ…',
  schemesTitle: 'ਸਰਕਾਰੀ ਸਕੀਮਾਂ',
  schemesText: 'ਇਸ ਕਾਗ਼ਜ਼ ਦੇ ਹਿਸਾਬ ਨਾਲ ਕਿਹੜੀਆਂ ਸਕੀਮਾਂ ਤੁਹਾਡੇ ਕੰਮ ਦੀਆਂ ਹੋ ਸਕਦੀਆਂ ਹਨ, ਸਮਝੋ ਸਰਕਾਰੀ ਸਕੀਮਾਂ ਦੀਆਂ ਵੈੱਬਸਾਈਟਾਂ ਉੱਤੇ ਵੇਖ ਸਕਦਾ ਹੈ।',
  schemesButton: 'ਮੇਰੇ ਲਈ ਸਕੀਮਾਂ ਲੱਭੋ',
  legalTitle: 'ਮੁਫ਼ਤ ਕਾਨੂੰਨੀ ਮਦਦ',
  legalText: 'ਕਾਨੂੰਨੀ ਸੇਵਾਵਾਂ ਅਥਾਰਟੀ ਤੋਂ ਤੁਹਾਨੂੰ ਮੁਫ਼ਤ ਵਕੀਲ ਮਿਲ ਸਕਦਾ ਹੈ — ਜਿਵੇਂ ਔਰਤਾਂ, ਬੱਚੇ, SC/ST, ਮਜ਼ਦੂਰ, ਦਿਵਿਆਂਗ ਅਤੇ ਘੱਟ ਆਮਦਨ ਵਾਲੇ ਲੋਕ।',
  legalCall: (n) => `${n} ਉੱਤੇ ਕਾਲ ਕਰੋ (ਮੁਫ਼ਤ)`,
  legalNearby: 'ਸਭ ਤੋਂ ਨੇੜਲੀ ਕਾਨੂੰਨੀ ਸੇਵਾਵਾਂ ਅਥਾਰਟੀ',
  legalMore: 'ਹੋਰ ਕਾਨੂੰਨੀ ਮਦਦ',
  legalAskConsent: 'ਤੁਹਾਡਾ ਸਵਾਲ ਇੰਟਰਨੈੱਟ ਰਾਹੀਂ ਸਮਝੋ ਦੇ ਸਰਵਰ ਅਤੇ ਇੱਕ AI ਸੇਵਾ (Groq) ਉੱਤੇ ਭੇਜਿਆ ਜਾਵੇਗਾ, ਜੋ ਜਵਾਬ ਸਿਰਫ਼ ਸਰਕਾਰੀ ਵੈੱਬਸਾਈਟਾਂ ਉੱਤੇ ਲੱਭਦੇ ਹਨ। ਆਧਾਰ, ਪੈਨ, ਫ਼ੋਨ ਨੰਬਰ ਅਤੇ ਈਮੇਲ ਪਹਿਲਾਂ ਹੀ ਹਟਾ ਦਿੱਤੇ ਜਾਂਦੇ ਹਨ। ਕੁਝ ਵੀ ਸੇਵ ਨਹੀਂ ਹੁੰਦਾ।',
  navLegal: 'ਕਾਨੂੰਨੀ ਮਦਦ'
}
